import './SelectModule.scss';
import { Select } from '@trackman/web-shared-components';
import { useTranslation } from 'react-i18next';
import { ModuleOverview } from 'types/module';

export const SelectModule = ({
  moduleList,
  selectedModuleId,
  selectModule,
}: {
  moduleList: ModuleOverview[];
  selectedModuleId: string | null;
  selectModule: (moduleId: string) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Select
      label={t('SelectModule', { ns: 'organizationPage' })}
      value={selectedModuleId ?? ''}
      className='select-module'
      onChange={(event) => selectModule(event.target.value as string)}
      selectOptions={moduleList
        .filter((module) => module.status === 'Visible')
        .map((module) => {
          return {
            label: module.title === ' ' ? t('PleaseSelectModule', { ns: 'organizationPage' }) : module.title,
            value: module.id,
          };
        })}
    />
  );
};
